import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  CREATE_SIGNUP_GENERATOR_SUCCESS,
  CREATE_SIGNUP_GENERATOR_ERROR,
  CLEAR_SIGNUP_GENERATOR_STATUS,
  DETELE_SIGNUP_GENERATOR_SUCCESS,
  DETELE_SIGNUP_GENERATOR_ERROR,
  FETCH_SIGNUP_GENERATOR,
  FETCH_SIGNUP_GENERATOR_ERROR,
  CLEAR_SIGNUP_GENERATOR,
  UPDATE_SIGNUP_GENERATOR_SUCCESS,
  UPDATE_SIGNUP_GENERATOR_ERROR,
  CLEAR_UPDATE_SIGNUP_GENERATOR_STATUS,
  FETCH_SIGNUP_SUBSCRIBERS_LIST,
  FETCH_SIGNUP_SUBSCRIBERS_LIST_ERROR,
  FETCH_SIGNUP_SUBSCRIBERS_LIST_CLEAR,
  FETCH_SIGNUP_SUBSCRIBERS_CSV,
  FETCH_SIGNUP_SUBSCRIBERS_CSV_ERROR,
  CLEAR_FETCH_SIGNUP_SUBSCRIBERS_CSV,
} from 'redux/signup-generator/types';

export const createSignupGenerator = () => baseErrorsHandlerDecorator(
  CREATE_SIGNUP_GENERATOR_SUCCESS,
  CREATE_SIGNUP_GENERATOR_ERROR,
  () => restapi.post(addLang('links/signup/generator/')),
  false,
);

export const deleteSignupGenerator = id => baseErrorsHandlerDecorator(
  DETELE_SIGNUP_GENERATOR_SUCCESS,
  DETELE_SIGNUP_GENERATOR_ERROR,
  () => restapi.delete(addLang(`links/signup/generator/${id}/`)),
  false,
);

export const clearSignupGeneratorStatus = () => dispatch => {
  dispatch({
    type: CLEAR_SIGNUP_GENERATOR_STATUS,
  });
};

export const fetchSignupGenerator = id => baseErrorsHandlerDecorator(
  FETCH_SIGNUP_GENERATOR,
  FETCH_SIGNUP_GENERATOR_ERROR,
  () => restapi.get(addLang(`links/signup/generator/${id}/`)),
  false,
);

export const clearSignupGenerator = () => dispatch => {
  dispatch({
    type: CLEAR_SIGNUP_GENERATOR,
  });
};

export const updateSignupGenerator = (id, formData) => baseErrorsHandlerDecorator(
  UPDATE_SIGNUP_GENERATOR_SUCCESS,
  UPDATE_SIGNUP_GENERATOR_ERROR,
  () => restapi.patch(addLang(`links/signup/generator/${id}/`), formData),
  false,
  true,
);

export const clearUpdateSignupGeneratorStatus = () => dispatch => {
  dispatch({
    type: CLEAR_UPDATE_SIGNUP_GENERATOR_STATUS,
  });
};

export const fetchSignupSubscribersList = (pageNumber = 1) => baseErrorsHandlerDecorator(
  FETCH_SIGNUP_SUBSCRIBERS_LIST,
  FETCH_SIGNUP_SUBSCRIBERS_LIST_ERROR,
  () => restapi.get(addLang(`links/signup/subscribers/?page=${pageNumber}`)),
  false,
);

export const clearSignupSubscribersList = () => dispatch => {
  dispatch({
    type: FETCH_SIGNUP_SUBSCRIBERS_LIST_CLEAR,
  });
};

export const fetchSignupSubscribersCsv = () => baseErrorsHandlerDecorator(
  FETCH_SIGNUP_SUBSCRIBERS_CSV,
  FETCH_SIGNUP_SUBSCRIBERS_CSV_ERROR,
  () => restapi.get(addLang('links/signup/subscribers/download/')),
  false,
);

export const clearFetchSignupSubscribersCsv = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_SIGNUP_SUBSCRIBERS_CSV,
  });
};
